import { t } from '@sm/intl';
import { Packages } from '~shared/constants/pricing';

import COPY from './copy';
import { PackageDef } from './types';

const PER_MONTH = t(COPY.PER_MONTH);
const PER_USER_PER_MONTH = t(COPY.PER_USER_PER_MONTH);
const BILLED_ANNUALLY = t(COPY.BILLED_ANNUALLY);
const BR_BILLED_ANNUALLY = t(COPY.BR_BILLED_ANNUALLY);

const PackageDefs: PackageDef = {
  [Packages.Basic]: {
    byline: t(COPY.ALWAYS_FREE),
  },
  [Packages.TeamAdvantage]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [Packages.TeamPremier]: {
    priceUnit: PER_USER_PER_MONTH,
    byline: BILLED_ANNUALLY,
  },
  [`${Packages.TeamAdvantage}_BR`]: {
    byline: BR_BILLED_ANNUALLY,
  },
  [`${Packages.TeamPremier}_BR`]: {
    byline: BR_BILLED_ANNUALLY,
  },
  [Packages.Enterprise]: {
    byline: t(COPY.ENTERPRISE),
  },
  [Packages.PremierAnnual]: {
    priceUnit: PER_MONTH,
  },
  [Packages.AdvantageAnnual]: {
    priceUnit: PER_MONTH,
    highlighted: true,
  },
  [Packages.StarterAnnual]: {
    priceUnit: PER_MONTH,
  },
  [Packages.StandardMonthly]: {
    priceUnit: PER_MONTH,
  },
  [Packages.Flex]: {
    priceUnit: PER_MONTH,
  },
  [Packages.FormsMonthly]: {
    priceUnit: PER_MONTH,
  },
  [Packages.FormsAnnual]: {
    priceUnit: PER_MONTH,
  },
};

export default PackageDefs;
